import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../components/header";
import Navbar from "../../components/navbar";
import CardUpDown from "../../components/cardupdown";
import CardLeftRight from "../../components/cardleftright";
import AdPage from "../../components/AdPage";
import { dataListsType } from "../../components/featured-posts";
import { DataLists } from "../../dataLists/DataLists";

export default function MorePage() {
  // const { state } = useLocation();
  // const dataProps = state?.dataProps || [];

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let category = decodeURIComponent(params.get("category") || "");
  let nation = decodeURIComponent(params.get("nation") || "");
  const label = decodeURIComponent(params.get("label") || "");

  const [dataProps, setdataProps] = useState<dataListsType[]>([]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getAllData = useCallback(() => {
    if (!category || !nation) return null;
    const data = [...DataLists];
    const allData = data.filter(
      (item) => item.category === category && item.nation === nation
    );
    setdataProps(allData);
  }, [category, nation, setdataProps]);

  useEffect(() => {
    getAllData();
  }, [category, getAllData, nation]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <Navbar />

      <AdPage />

      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center max-w-[888px] my-8">
          <h1 className="w-full text-xl font-bold px-8 pb-6">{label}</h1>
          <div className="w-full mb-16 px-8">
            <div className="w-full flex flex-col gap-y-10 mt-2 px-2">
              {windowWidth > 800 ? (
                <CardLeftRight props={dataProps.slice(0)} />
              ) : (
                <CardUpDown props={dataProps.slice(0)} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
